import { CustomAxios, getResponseData } from '../../redux/axios';

export type ResetUserRequest = {
  userId: string[];
  username?: string[];
  ip?: string[];
  jti?: string[];
};

export type ResetUserResponse = {
  status: string;
};

// Same endpoint used by the Block User(s) page, scoped to a single userId.
export const resetUser = (userId: string) =>
  CustomAxios.post<ResetUserResponse>('/auth-api/v3/users/reset', {
    userId: [userId],
  }).then(getResponseData);
